var babelHelpers = require('./babel-helpers.js');
/**
 * MUI React layout module
 * @module react/layout
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = babelHelpers.interopRequireDefault(_react);

/**
 * Panel constructor
 * @class
 */
var Panel = function (_React$Component) {
  babelHelpers.inherits(Panel, _React$Component);

  function Panel() {
    babelHelpers.classCallCheck(this, Panel);
    return babelHelpers.possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).apply(this, arguments));
  }

  babelHelpers.createClass(Panel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          reactProps = babelHelpers.objectWithoutProperties(_props, ['children', 'className']);


      return _react2.default.createElement(
        'div',
        babelHelpers.extends({}, reactProps, {
          className: 'mui-panel ' + className
        }),
        children
      );
    }
  }]);
  return Panel;
}(_react2.default.Component);

/** Define module API */


Panel.defaultProps = {
  className: ''
};
exports.default = Panel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/muicss/lib/react/panel.js
// module id = 62
// module chunks = 0